import { NavLink } from 'react-router-dom'

const media = ({ className }: { className?: string }) => {
  return (
    <ul className={className}>
      <li>
        <NavLink to="media/checkSureShare">บทความเช็ก ชัวร์ แชร์</NavLink>
      </li>
      <li>
        <NavLink to="media/vdocheckSureShare">วิดีโอเช็ก ชัวร์ แชร์</NavLink>
      </li>
      <li>
        <NavLink to="media/newsUpdate">ข่าว</NavLink>
      </li>
      <li>
        <NavLink to="media/infoGraphic">อินโฟกราฟิก</NavLink>
      </li>
      <li>
        <NavLink to="media/animation">แอนิเมชัน</NavLink>
      </li>
      <li>
        <NavLink to="media/video">วิดีโอ</NavLink>
      </li>
      <li>
        <NavLink to="media/e-book">E-book</NavLink>
      </li>
      {/* <li>
        <NavLink to="media/podcast">Podcast</NavLink>
      </li> */}
      <li>
        <NavLink to="media/factSheet">Factsheet</NavLink>
      </li>
      <li>
        <NavLink to="media/misc">เบ็ดเตล็ด</NavLink>
      </li>
    </ul>
  )
}
const service = ({ className }: { className?: string }) => {
  return (
    <ul className={className}>
      <li>
        <NavLink to="check-product-serial">ตรวจเลขผลิตภัณฑ์</NavLink>
      </li>
      <li>
        <NavLink to="media/podcast">Podcast</NavLink>
      </li>
      <li>
        <NavLink to="appeal">แจ้งเรื่องร้องเรียน</NavLink>
      </li>
      <li>
        <NavLink to="form-check-sure-share">แจ้งเรื่องเช็กให้ชัวร์กับ อย.</NavLink>
      </li>

      <li>
        <a target="_blank" rel="noreferrer" href="https://www.medcannabis.go.th/">
          กัญชาทางการแพทย์
        </a>
      </li>

      <li>
        <a href="https://fda.go.th/" target="_blank" rel="noreferrer">
          FDA Center
        </a>
      </li>
      <li>
        <a href={process.env.REACT_APP_QUESTION_FORM} target="_blank" rel="noreferrer">
          แบบสอบถาม
        </a>
      </li>
      <li>
        <NavLink to="contact?view=form" state={{ subject: 'แนะนำติชม' }}>
          แนะนำติชม
        </NavLink>
      </li>
      <li>
        <NavLink to="media/illegalProduct">เตือนภัยผลิตภัณฑ์สุขภาพผิดกฎหมาย</NavLink>
      </li>
    </ul>
  )
}

const knowledge = ({ className }: { className?: string }) => {
  return (
    <ul className={className}>
      <li>
        <NavLink to="media/men">เกี่ยวกับผู้ชาย</NavLink>
      </li>
      <li>
        <NavLink to="media/women">เกี่ยวกับผู้หญิง</NavLink>
      </li>
      <li>
        <NavLink to="media/elder">เกี่ยวกับผู้สูงอายุ</NavLink>
      </li>
      <li>
        <NavLink to="media/kids">เกี่ยวกับเด็ก</NavLink>
      </li>
      <li>
        <NavLink to="media/entrepreneur">เกี่ยวกับผู้ประกอบการ</NavLink>
      </li>
      <li>
        <NavLink to="media/ncds">โรคไม่ติดต่อเรื้อรัง (NCDs)</NavLink>
      </li>
      <li>
        <a target="_blank" rel="noreferrer" href="https://gda.oryor.com/">
          ฉลาก หวาน มัน เค็ม (GDA)
        </a>
      </li>
    </ul>
  )
}

export { media, service, knowledge }
